export const BASE_PROMPTS: string[] = [
    'Худшая причина опоздать на работу — ...',
    'Если бы коты умели говорить, они бы сказали: ...',
    'Что никогда не стоит говорить на первом свидании: ...',
    'Название несуществующего фильма ужасов про офис: ...',
    'Самое странное, что можно найти в чужом холодильнике: ...',
    'Девиз этой компании на ближайший год: ...',
    'Что бы написали на надгробии программиста: ...',
    'Худший подарок на Новый год: ...',
    'Если бы наш чат был фильмом, как бы он назывался: ...',
    'Что бы сказал кот, если бы вёл дневник: ...',
    'Самое неловкое, что можно сказать боссу: ...',
    'Название бренда одежды для зомби: ...',
    'Что стоит написать в резюме, но никто не пишет: ...',
    'Худшее название для кофейни: ...',
    'Что бы произошло, если бы гравитация работала через раз: ...',
    'Самая нелепая суперспособность: ...',
    'Что бы сказал будильник, если бы мог защищаться: ...',
    'Худший слоган для стоматологии: ...',
    'Что точно не стоит писать в рабочем чате в пятницу вечером: ...',
    'Название несуществующей социальной сети только для котов: ...',
    'Самая странная традиция, которую можно придумать для семьи: ...',
    'Что бы сказал холодильник, если бы устал от твоих полуночных визитов: ...',
    'Худшее оправдание для отмены встречи: ...',
    'Название кулинарного шоу для людей, которые не умеют готовить: ...',
    'Что бы написал робот-пылесос в своих мемуарах: ...',
    'Самое неожиданное, что может быть написано на чеке из супермаркета: ...',
    'Худший вопрос на собеседовании: ...',
    'Что бы сказал светофор, если бы устал ждать: ...',
    'Название несуществующего реалити-шоу про офис: ...',
    'Самая странная причина завести домашнее животное: ...',
];
